import styled from 'styled-components'

export const TabList = styled.div`
  display: flex;
  margin-bottom: 18px;
  gap: 18px;
  position: relative;
  width: 100%;

  @media only screen and (max-width: 1450px) {
    gap: 11px;
  }

  @media only screen and (max-width: 800px) {
    gap: 5px;
    padding: 15px;
    margin-bottom: 0;
  }
`

export const CardWrapper = styled.div`
  height: 300px;
  width: 300px;

  @media only screen and (max-width: 1450px) {
    width: 250px;
    height: 250px;
  }

  @media only screen and (max-width: 1000px) {
    width: 42vw;
    height: 42vw;
  }
`

export const TabButton = styled.button`
  height: 42px;
  max-width: 172px;
  width: 18%;
  border-radius: 6px;
  background: ${({ isActive }) => (isActive ? '#FF5E6D' : '#fff')};
  color: ${({ isActive }) => (isActive ? 'white' : 'black')};
  font-family: Helvetica Neue;
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0em;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  padding: 0;
  cursor: pointer;
  filter: drop-shadow(0px 1px 4px rgba(0, 0, 0, 0.1));

  @media only screen and (max-width: 800px) {
    border: 0.5px solid #d8d8d8;
    height: 26px;
    width: auto;
    padding: 0 20px;
    font-family: Helvetica Neue;
    font-size: 12px;
    font-weight: 400;
    line-height: 14px;
    color: ${({ isActive }) => (isActive ? '#fff' : '#000')};
    background: ${({ isActive }) => (isActive ? '#FF5E6D' : '#f2f2f2')};
  }
`

export const RowTitle = styled.span`
  font-family: Helvetica Neue;
  font-size: 20px;
  font-weight: 500;
  line-height: 24px;
  margin: 0 0 20px;
  display: block;

  @media only screen and (max-width: 800px) {
    margin: 0 0 5px;
    padding: 0 20px;
    font-size: 16px;
    position: relative;

    &::after {
      content: '';
      display: block;
      width: calc(100% - 40px);
      height: 1px;
      background: #d8d8d8;
      position: absolute;
      bottom: -8px;
      left: 20px;
    }
  }
`
